<template>
  <div class="bg-gray-700 pt-3 rounded-t-none rounded-lg">
    <div class="flex justify-around pt-2 pb-4">
      <div
        @click="
          setGridMode('free')
          $emit('closeMenu')
        "
        class="flex flex-col items-center cursor-pointer"
      >
        <div class="flex items-center pb-2">
          <img
            v-if="gridMode === 'free'"
            class="w-8 h-8 cursor-pointer"
            src="../../assets/icons/freeModeOn.svg"
            alt="Mode libre on"
          />
          <img v-else class="w-8 h-8 cursor-pointer" src="../../assets/icons/freeModeOff.svg" alt="Mode libre off" />
        </div>
        <div class="text-base" :class="[gridMode === 'free' ? 'text-white' : 'text-gray-600']">
          Libre
        </div>
      </div>
      <div
        @click="
          setGridMode('group')
          $emit('closeMenu')
        "
        class="flex flex-col items-center cursor-pointer"
      >
        <div class="flex items-center pb-2">
          <img
            v-if="gridMode === 'group'"
            class="w-8 h-8 cursor-pointer"
            src="../../assets/icons/groupModeOn.svg"
            alt="Mode lignes on"
          />
          <img v-else class="w-8 h-8 cursor-pointer" src="../../assets/icons/groupModeOff.svg" alt="Mode lignes off" />
        </div>
        <div class="text-base" :class="[gridMode === 'group' ? 'text-white' : 'text-gray-600']">
          Lignes
        </div>
      </div>

      <div
        @click="
          setGridMode('grid')
          $emit('closeMenu')
        "
        class="flex flex-col items-center cursor-pointer"
      >
        <div class="flex items-center pb-2">
          <img
            v-if="gridMode === 'grid' || gridMode === 'label'"
            class="w-8 h-8 cursor-pointer"
            src="../../assets/icons/gridModeOn.svg"
            alt="Mode grille on"
          />
          <img v-else class="w-8 h-8 cursor-pointer" src="../../assets/icons/gridModeOff.svg" alt="Mode grille off" />
        </div>
        <div class="text-base" :class="[gridMode === 'grid' || gridMode === 'label' ? 'text-white' : 'text-gray-600']">
          Grille
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
  computed: {
    ...mapState({
      gridMode: state => state.grid.gridMode
    })
  },
  methods: {
    ...mapMutations("grid", ["setGridMode"])
  }
}
</script>

<style></style>
